import { render, staticRenderFns } from "./YtdDetailApp.vue?vue&type=template&id=4810e942&scoped=true"
import script from "./YtdDetailApp.vue?vue&type=script&lang=js"
export * from "./YtdDetailApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4810e942",
  null
  
)

export default component.exports